import React from 'react';
import { ProjectStatus } from 'types';
import { Title } from '@cognite/cogs.js';
import { useWorkSteps } from 'redux/reducers/worksteps';
import { hasReviewerCommentsAfterResolved } from 'pages/EditProcedure/components/Worksteps/Review/Resolved';
import {
  ResolveActionTitle,
  StepsForRevisionWarning,
  Container,
} from './elements';

export type Props = {
  projectStatus: ProjectStatus;
  backgroundColor?: string;
  hideTitle?: boolean;
  isWorkStepsResolved?: boolean;
};

export const StepRevision = ({
  projectStatus,
  backgroundColor = '#fdf3f5',
  hideTitle = false,
  isWorkStepsResolved = true,
}: Props) => {
  const { stepsNeedRevision } = useWorkSteps();

  const items = stepsNeedRevision();

  if (items?.length) {
    return (
      <>
        <StepsForRevisionWarning backgroundColor={backgroundColor}>
          {!hideTitle && (
            <Title level={5} style={{ textAlign: 'left' }}>
              STEPS THAT NEED REVISION
            </Title>
          )}
          {!isWorkStepsResolved && (
            <ResolveActionTitle level={2} aria-label="step-errors">
              Not all steps have been revised
            </ResolveActionTitle>
          )}
        </StepsForRevisionWarning>
        <Container
          style={{ backgroundColor }}
          data-testid="steps-for-revision"
          direction="row"
          wrap="wrap"
          alignItems="center"
        >
          {items.map((item, index) => {
            let stepDone = false;
            const lastItem = index === items?.length - 1;
            if (projectStatus === 'compilation') {
              stepDone =
                !!item?.review?.resolved?.compiler?.date &&
                !hasReviewerCommentsAfterResolved(item);
            }
            if (projectStatus === 'review') {
              stepDone = !!item?.review?.resolved?.reviewer?.date;
            }
            return (
              <div
                key={`step-revision-${item?.position}`}
                style={{
                  color: stepDone
                    ? 'var(--cogs-greyscale-grey6)'
                    : 'var(--cogs-text-color)',
                }}
              >
                <span
                  data-testid={`step-revision-${item?.position}`}
                  style={{
                    textDecoration: stepDone ? 'line-through' : 'none',
                  }}
                >
                  {item?.position}
                </span>
                {!lastItem && (
                  <span
                    key={`step-revision-spacer-${item?.position}`}
                    style={{ marginRight: '4px' }}
                  >
                    ,
                  </span>
                )}
              </div>
            );
          })}
        </Container>
      </>
    );
  }
  return null;
};
